/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import styled from "@emotion/styled";

const Default = styled.button`
  padding: 1.5rem 4rem;
  border-radius: 1rem;
  border: none;
  color: #50976a;
  transtion: all 0.2s ease;
  cursor: pointer;
  outline: none;
  font-size: 2rem;
  border: 2px solid #e2f4de;
  box-shadow: 0px 6px 14px rgba(0, 0, 0, 0.06);
`;

const Button = ({ children, type, style, ...props }) => {
  let buttonStyle;
  switch (type) {
    case "secondary":
      buttonStyle = {
        backgroundColor: "transparent",
      };
      break;
    case "link":
      buttonStyle = {
        border: "none",
        borderRadius: "4rem",
        backgroundColor: "transparent",
      };
      break;
    case "dangerous":
    default:
      buttonStyle = {
        backgroundColor: "#e2f4de",

        "&:hover": {
          backgroundColor: "transparent",
        },
      };
  }
  return (
    <Default css={{ ...buttonStyle, ...style }} {...props}>
      {children}
    </Default>
  );
};

export default Button;
